import { request } from '../../helpers'

export default {
  async listCustomerFormSubmissions({ queryParameters = {}, expand = [] } = {}) {
    return (
      await request({
        url: 'customer_form_submissions',
        queryParameters,
        expand,
      })
    ).data
  },

  async createWaiverAgreement(data = {}) {
    return (
      await request({
        method: 'POST',
        url: 'waiver_agreements',
        data,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    ).data
  },

  async createFormSubmission(data = {}) {
    return (
      await request({
        method: 'POST',
        url: 'customer_form_submissions',
        data,
      })
    ).data
  },
}
